import { makeObservable, computed } from 'mobx'
import { task } from 'mobx-task'
import Member from 'iam/models/Member'
import { GetCurrentMember } from 'iam/SessionStore'
import Job from 'jobs/Job'
import { Room, RoomStatus } from 'messaging/rooms/Room'
import RoomStore from 'messaging/rooms/RoomStore'

export default class RoomViewModel {
  constructor(
    private readonly job: Job,
    private readonly roomStore: RoomStore,
    private readonly getCurrentMember: GetCurrentMember,
  ) {
    makeObservable(this)
  }

  @computed
  get isRoomClosed() {
    return this.room.status === RoomStatus.Closed
  }

  @computed
  get participants(): Array<Member> {
    return this.room.activeParticipants.items
  }

  @computed
  get activeRoom(): boolean {
    return this.room.status === RoomStatus.Active
  }

  @computed
  get room() {
    return this.roomStore.rooms.get(this.job.consultation?.room.id) ?? Room.none
  }

  join = task.resolved(async () => {
    const roomDescriptor = await this.roomStore.joinRoom(this.room.id)

    if (roomDescriptor.type === 'Whereby') {
      const roomUrl = new URL(roomDescriptor.roomUrl)
      const displayName = this.getCurrentMember().displayName

      window
        .open(`${roomUrl}&displayName=${displayName}&logo=off`, '_blank')
        ?.focus()
    }
  })
}
